import * as ContextMenu from "ol-contextmenu";
import * as olProj from 'ol/proj';
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";
import RenderFeature from "ol/render/Feature";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Point from "ol/geom/Point";
import Stroke from "ol/style/Stroke";
import Icon from 'ol/style/Icon';
import Text from 'ol/style/Text';
import olMap from 'ol/Map';
import { Coordinate } from "ol/coordinate";

export class MapContextMenu {
   
    protected _contextMenu: ContextMenu;
    protected _vectorLayer: VectorLayer;
    
    protected _removeMarkerItem: any;
    protected _items: Array<any>;

    public constructor(
        private _map: olMap,
        private iconUrl: string = "/images/pin_drop.png"
    ) {
        this._vectorLayer = new VectorLayer({ source: new VectorSource() });
        this.init();
    }

    private init = (): void => {       
            let self = this;
           
            self._map.addLayer(self._vectorLayer);
            self._items = [
                '-', // this is a separator
                {
                    text: '<i class="fa fa-crosshairs" aria-hidden="true"></i>Center map here',
                    callback: function (obj) {
                        self.centerMap([obj.coordinate[0], obj.coordinate[1]]);
                    }
                },
                '-', // this is a separator
                {
                    text: '<i class="fa fa-solid fa-location-dot"></i>Google Maps',
                    callback: function (obj) {
                        self.openGoogleMaps([obj.coordinate[0], obj.coordinate[1]]);
                    }
                }
                //{
                //    text: '<i class="fa fa-map-marker" aria-hidden="true"></i>Add a marker}',
                //    callback: function (obj) {
                //        self.addMarker([obj.coordinate[0], obj.coordinate[1]]);
                //    }
                //}
            ];

            //self._removeMarkerItem = {
            //    text: '<i class="fa fa-trash" aria-hidden="true"></iRemove marker',
            //    classname: 'marker',
            //    callback: function (obj) {
            //        self.removeMarker(obj.data.marker);
            //    }
            //};
        
            self._contextMenu = new ContextMenu({
                width: 170,
                defaultItems: true,
                items: self._items
            });

            self._contextMenu.on('beforeopen', (evt) => {
                let element = self._map.getTargetElement();
                let { top, left } = element.getBoundingClientRect();

                //EDGE does not support document.elementsFromPoint
                if (document.elementsFromPoint && document.elementsFromPoint(evt.pixel[0] + left, evt.pixel[1] + top).some(e => e.id === 'popup')) {
                    self._contextMenu.disable();
                    return;
                }
            });

            self._contextMenu.getDefaultItems()[0].text = "Zoom in";
            self._contextMenu.getDefaultItems()[1].text = "Zoom out";

            self._contextMenu.on('open', function (evt) {
                let feature: Feature | RenderFeature = self._map.forEachFeatureAtPixel(evt.pixel, function (ft, l) {
                    return ft;
                });
                if (feature && feature.get('type') === 'removable') {
                    self._contextMenu.clear();
                    self._removeMarkerItem.data = {
                        marker: feature
                    };
                    self._contextMenu.push(self._removeMarkerItem);
                } else {
                    self._contextMenu.clear();
                    self._contextMenu.extend(self._contextMenu.getDefaultItems());
                    self._contextMenu.extend(self._items);
                }
            });
           
            self._map.addControl(self._contextMenu);         
    }

    public addItems = (items: Array<any>): void => {
        this._contextMenu.extend(items);
        this._items = this._items.concat(items);
    }

    private centerMap = (coordinate: [number, number]): void => {
        this._map.getView().animate({ center: coordinate });
    }

    private openGoogleMaps = (coordinate: [number, number]): void => {
        let coord4326: Coordinate = olProj.transform(coordinate, "EPSG:3857", "EPSG:4326");
        let url = encodeURI(`https://www.google.com/maps/search/?api=1&query=${coord4326[1]},${coord4326[0]}`);
        window.open(url, '_blank');        
    }

    public activate = ():void => {
        this._contextMenu.enable();
    }   

    public deactivate = (): void => {
        this._contextMenu.disable();
    }

    //public addMarker = (coordinate: [number, number]): void => {
    //    let template = 'Coordinate is ({x} | {y})',
    //        iconStyle = new Style({
    //            image: new Icon({ scale: .6, src: this.iconUrl }),
    //            text: new Text({
    //                offsetY: 25,
    //                text: this.getGridRef(coordinate),
    //                font: '15px Open Sans,sans-serif',
    //                fill: new Fill({ color: '#111' }),
    //                stroke: new Stroke({ color: '#eee', width: 2 })
    //            })
    //        }),
    //        feature = new Feature({
    //            type: 'removable',
    //            geometry: new Point(coordinate)
    //        });

    //    feature.setStyle(iconStyle);
    //    this._vectorLayer.getSource().addFeature(feature);
    //}

    //private getGridRef = (coordinate: [number, number]): string => {
    //    //transform from display projection to data projection
    //    let coords = olProj.transform(coordinate, this._map.options.displayProjection, this._map.options.dataProjection);
    //    return `${coords[0].toFixed(0)} ${coords[1].toFixed(0)}`;
    //}

    //private removeMarker = (marker: Feature): void => {
    //    this._vectorLayer.getSource().removeFeature(marker);
    //}
}